/*
  FLOW deal upgrade button in the cart drawer (snippets/cart-flow-upgrade.liquid).
  Sets the cart line's own quantity input and fires its change event, so the theme's cart code
  (main.js) updates the cart, the discounts and the drawer the same way the + button does.
  Delegated on document because the drawer's HTML is replaced after every cart change.
*/
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-cart-upgrade]');
  if (!button) return;

  var input = document.getElementById('Drawer-quantity-' + button.dataset.line);
  if (!input) return;

  button.disabled = true;
  button.classList.add('is-loading');
  input.value = button.dataset.qty;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
